/*

@@author        j0Shi
@@date          2019.11.08
@@desc          Functions and data used by multiple picker modal components
@@usedby        ObjectVacancyModal -> Object
                SearchPickerModal -> Search/Home

*/

import { breakpoint, setupMediaQueries, killMediaListeners } from 'mixins/composition/DeviceHelper';

import {
  computed, ref,
} from '@vue/composition-api';

// data vars
const modalName = ref('picker-modal');

// modal logic
const modalLogic = () => {
  const modalInitialized = ref(false);
  const modalReady = ref(false);

  // opens the modal when the click event is emitted by the button
  // need to provide $modal function because no access to this
  const openModal = ($modal) => {
    // first click inits the component
    modalReady.value = true;
    // check init state and open modal in case
    if (modalInitialized.value) $modal.show(modalName.value);
  };

  // inits the modal when the ready state was emitted by the modal component
  const initModal = ($modal) => {
    modalInitialized.value = true;
    openModal($modal);
  };

  // toogle scroll-off class on html element to prevent scrolling behind the modal
  const togglePreventScroll = (state) => {
    if (state) {
      document.querySelector('html').classList.add('scroll-off');
    } else {
      document.querySelector('html').classList.remove('scroll-off');
    }
  };

  return {
    modalReady,
    togglePreventScroll,
    openModal,
    initModal,
  };
};

const install = () => {
  setupMediaQueries();
};

const deinstall = () => {
  killMediaListeners();
};

// check for mobile breakpoints up to md
const isMobile = computed(() => ['xs', 'sm', 'md'].includes(breakpoint.value));

// calendar months based on the current breakpoint
const calendarMonthCount = computed(() => (breakpoint.value === 'md' ? 2 : 1));

export {
  install, deinstall, isMobile, calendarMonthCount, modalLogic, modalName,
};
